import { Capacitor } from "@capacitor/core";

export type Platform = "ios" | "android" | "pwa" | "web";

export const platformService = {
  /**
   * Check if running as native Capacitor app
   */
  isNative(): boolean {
    return Capacitor.isNativePlatform();
  },

  /**
   * Check if running as installed PWA
   */
  isPWA(): boolean {
    return (
      !this.isNative() &&
      (window.matchMedia("(display-mode: standalone)").matches ||
        (window.navigator as { standalone?: boolean }).standalone === true)
    );
  },

  /**
   * Check if running in regular browser
   */
  isBrowser(): boolean {
    return !this.isNative() && !this.isPWA();
  },

  /**
   * Get current platform
   */
  getPlatform(): Platform {
    if (Capacitor.getPlatform() === "ios") return "ios";
    if (Capacitor.getPlatform() === "android") return "android";
    if (this.isPWA()) return "pwa";
    return "web";
  },

  /**
   * Check if push notifications are supported
   */
  supportsPushNotifications(): boolean {
    if (this.isNative()) {
      return true;
    }
    return "serviceWorker" in navigator && "PushManager" in window;
  },

  /**
   * Check if local notifications are supported (native only)
   */
  supportsLocalNotifications(): boolean {
    return this.isNative();
  },
};
